module.exports = __webpack_public_path__ + "assets/refund.5d17092e.svg";